import type {
  AdminExpense,
  AdminExpenseListResponse,
  AdminExpenseResponse,
  AdminExpenseVersionListResponse,
  SaveExpenseRequest,
  UpdateExpenseRequest,
} from '@mds/shared/types/expense';
import type { PresignedFileDownloadResponse } from '@mds/shared/types/file';

import { api } from '@/lib/api';

export type ExpenseQuery = {
  page?: number;
  limit?: number;
  q?: string;
  from?: string;
  to?: string;
  method?: 'cash' | 'whish' | 'omt' | 'other';
  sort?: 'createdAt' | 'expenseDate' | 'amountMinor' | 'reference' | 'updatedAt';
  direction?: 'asc' | 'desc';
};

export const listExpenses = (query: ExpenseQuery = {}) =>
  api.get<AdminExpenseListResponse>('admin/expenses', { query });

export const getExpense = (expenseId: string): Promise<AdminExpense> =>
  api.get<AdminExpenseResponse>(`admin/expenses/${expenseId}`).then((response) => response.data);

export const createExpense = (body: SaveExpenseRequest): Promise<AdminExpense> =>
  api.post<AdminExpenseResponse>('admin/expenses', body).then((response) => response.data);

export const updateExpense = (
  expenseId: string,
  body: UpdateExpenseRequest,
): Promise<AdminExpense> =>
  api
    .patch<AdminExpenseResponse>(`admin/expenses/${expenseId}`, body)
    .then((response) => response.data);

export const listVersions = (expenseId: string, page = 1, limit = 25) =>
  api.get<AdminExpenseVersionListResponse>(`admin/expenses/${expenseId}/versions`, {
    query: { page, limit },
  });

export const attachmentDownloadUrl = (expenseId: string, fileId: string) =>
  api
    .get<PresignedFileDownloadResponse>(
      `admin/expenses/${expenseId}/attachments/${fileId}/download-url`,
    )
    .then((response) => response.data);
